module.exports = __webpack_public_path__ + "img/headset2.6021075f.jpg";